import React, { useState } from "react";
import PropTypes from "prop-types";

import Error from "src/shared/components/Error";
import * as STabs from "src/shared/components/Tabs/styled";
import { isVerticalLiving } from "src/shared/experts/utilities/segments";
import contactProps from "src/shared/utilities/graphql/contactProps";

import { RENTAL, SALE } from "../../constants/dealTypes";
import useDeals from "../../utilities/hooks/useDeals";
import useFeatureState from "../../utilities/hooks/useFeatureState";
import { getHeaderText } from "../../utilities/segments";
import DealsTable from "../DealsTable";
import * as S from "./styled";

const Deals = ({ contact }) => {
  const { segmentName } = useFeatureState();
  const { error, loading, rentals, sales } = useDeals({
    contact_id: contact.id
  });

  const [showType, changeShowType] = useState(SALE);

  const displaySales = () => changeShowType(SALE);
  const displayRentals = () => changeShowType(RENTAL);
  const verticalLivingExpert = isVerticalLiving(segmentName);
  const showDealTypeButtons =
    Boolean(rentals?.totalCount ?? 0) && verticalLivingExpert;
  const headerText = getHeaderText();

  if (loading) {
    return <>Loading...</>;
  }

  if (error) {
    return (
      <Error>
        There was an error loading this agent’s information, please try again
        later
      </Error>
    );
  }

  return (
    <S.Wrapper>
      <S.Header>
        <S.HeaderText>
          {headerText}
          {!showDealTypeButtons && ` (${sales.totalCount})`}
        </S.HeaderText>
        {showDealTypeButtons && (
          <STabs.Tabset>
            <STabs.Tab highlighted={showType === SALE} onClick={displaySales}>
              Sales ({sales.totalCount})
            </STabs.Tab>
            <STabs.Tab
              highlighted={showType === RENTAL}
              onClick={displayRentals}
            >
              Rentals ({rentals.totalCount})
            </STabs.Tab>
          </STabs.Tabset>
        )}
      </S.Header>
      <DealsTable contact={contact} type={showType} />
    </S.Wrapper>
  );
};

Deals.propTypes = {
  contact: PropTypes.shape(contactProps).isRequired
};

export default Deals;
